import React, { ReactNode } from 'react';
import styles from './LandingZonesWrapper.module.css';

/**
 * Full-bleed layout wrapper for the landing-zones section.
 *
 * The embedded tool is a map and needs the whole viewport, whereas the shared
 * AppIaRWrapper caps content at 844px. That wrapper is also used by the
 * Responders page, so it cannot be widened here; this is a section-local
 * replacement rather than an edit to shared layout.
 *
 * The height chain resolves because MainContainer has a definite height and
 * AppWrapper is a stretched flex child — the same thing AppIaRWrapper relies on.
 */
const LandingZonesWrapper = ({ children }: { children?: ReactNode }) => (
  <div className={styles.wrapper}>{children}</div>
);

export default LandingZonesWrapper;
